import styled from "styled-components";
import compose_logo_dark from "../../imgs/compose_logo_half.svg";
import compose_logo_light from "../../imgs/compose_logo_light_half.svg";
const LogoImg = styled.img.attrs((props) => ({
    src: props.theme.themeType === "dark" ? compose_logo_dark : compose_logo_light
  }))`
    margin-left: 32px;
    margin-top: 16px;
    margin-bottom: 16px;
  `;

export default LogoImg;
